export const MESSAGE_DISPLAY_FAST_ID = 'MessageDisplay'; // legacy
export const INVALID_FILE_TYPE = 'Unsupported file format. Please upload a valid image file';
